import React from 'react';
import { HardHatIcon } from 'lucide-react';
import { BoardConfig } from '../../models/appState';
import { getIconComponent } from '../../utils/icon';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

interface BoardTypeDropdownItemProps {
  board: BoardConfig;
  boardType: string;
  onSelect: (type: string) => void;
}

const BoardTypeDropdownItem: React.FC<BoardTypeDropdownItemProps> = ({
  board,
  boardType,
  onSelect,
}) => {
  const isActive = board.isEnable;
  const isSelected = boardType === board.key;
  const IconComponent = board.uiConfig
    ? getIconComponent(board.uiConfig) ?? HardHatIcon
    : HardHatIcon;
  const iconProps =
    (isActive && isSelected
      ? board.uiConfig?.icon.props
      : board.uiConfig?.icon.disabledProps) ?? {};
  const colorCode = board.uiConfig?.colorCode || 'blue';
  const textColor = isSelected ? `text-${colorCode}-700` : 'text-gray-700';
  const bgColor = isSelected ? `bg-${colorCode}-50` : '';

  const handleClick = () => {
    if (isActive) {
      onSelect(board.key);
    }
  };

  return (
    <DropdownMenuItem
      onClick={handleClick}
      disabled={!isActive}
      className={`flex items-center gap-3 cursor-pointer ${
        !isActive ? 'opacity-50 cursor-not-allowed' : ''
      } ${isSelected ? bgColor : ''} ${textColor}`}
    >
      <div className={!isActive ? 'opacity-50' : ''}>
        {board.uiConfig?.icon && (
          <IconComponent className="h-4 w-4" {...iconProps} />
        )}
      </div>
      <span>{board.title}</span>
    </DropdownMenuItem>
  );
};

export default BoardTypeDropdownItem;
